import styled from 'react-emotion';
import { theme } from '@ublend-npm/aulaui-next';

type RectangleProps = {
  width?: number;
  height?: number;
  opacity?: number;
  marginRight?: string;
};

export const Rectangle = styled.span<RectangleProps>`
  display: inline-block;
  border-radius: ${theme.borderRadius.medium};
  width: ${({ width }) => width}px;
  height: ${({ height }) => height}px;
  background-color: ${theme.color.grayDark};
  opacity: ${({ opacity }) => opacity || 1};
  margin-right: ${({ marginRight }) => `${marginRight || 0}px`};
`;

type ListItemContainerProps = {
  title?: boolean;
  alignRight?: boolean;
};

export const ListItemContainer = styled.li<ListItemContainerProps>`
  padding: ${({ title }) => (title ? '24px' : '0')} 12px 0 8px;
  box-sizing: border-box;
  height: ${({ title }) => (title ? '66px' : '32px')};
  vertical-align: middle;
  text-align: ${({ alignRight }) => (alignRight ? 'right' : 'left')};
`;
